export let router = {
  path: "youyueBrand",
  name: "youyueBrand",
  meta: {
    title: "优越品牌",
    title_en: "BRAND",
    showOnNavMenu: true,
    navMenuMode: "custom",
    iconfont: "icon-chanpin",
    dropDown: true,
    subBar: true,
  },
  redirect() {
    return { name: "brandShow" };
  },
  children: [
    {
      path: "brandShow",
      name: "brandShow",
      meta: {
        title: "优越品牌产品展示",
        dropDown: false,
        showOnNavMenu: true,
      },
      component: () => import("@/views/brand/brandShow/index.vue"),
    },
    {
      path: "brandLicensing",
      name: "brandLicensing",
      meta: {
        title: "品牌授权",
        dropDown: false,
        showOnNavMenu: true,
      },
      component: () => import("@/views/brand/brandLicensing/index.vue"),
    },
    {
      path: "brandShare",
      name: "brandShare",
      meta: {
        title: "共建品牌",
        dropDown: false,
        showOnNavMenu: true,
      },
      component: () => import("@/views/brand/brandLicensing/index.vue"),
    },
    {
      path: "brandProductDetail",
      name: "productDetails",
      meta: {
        title: "商品详情",
        dropDown: false,
        showOnNavMenu: false,
      },
      component: () => import("@/views/brand/productDetails/productDetails.vue"),
    },
  ],
};
